import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Image from 'apps/new-web/views/components/image';

const MenuItem = (props) => {
  const { icon, className, description, label, href, target } = props;

  return (
    <li className={ classNames('post-login-menu-item-component', className) }>
      <a
        className="menu-item-link"
        href={ href }
        target={ target }
      >
        { icon &&
          <Image className="icon" src={ 'components/header/post-login-navigation/img/' + icon } />
        }
        <span className={ classNames('label', { 'no-description': !description }) }>{ label }</span>
        { description &&
          <p className="description">{ description }</p>
        }
      </a>
    </li>
  );
};

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  target: PropTypes.string
};

export default MenuItem;
